import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { UserContext } from 'contexts/UserContext';
import { isAdmin } from 'utils/common';

const readStoredUser = () => {
  try {
    const raw = localStorage.getItem('user');
    return raw ? JSON.parse(raw) : undefined;
  } catch (error) {
    return undefined;
  }
};

const RoleGuard = ({ roles, children }) => {
  const currentUser = useSelector((state) => state.account.user) || readStoredUser();
  const { isUserLoaded } = useContext(UserContext);

  if (!roles || roles.length === 0) {
    return children;
  }

  if (!isUserLoaded) {
    return null;
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  const bizRole = isAdmin() ? 'admin' : currentUser.biz_role;

  if (!roles.includes(bizRole)) {
    if (bizRole === 'guest') {
      return <Navigate to="/guest-h5?hotel_id=1" replace />;
    }
    return <Navigate to="/panel" replace />;
  }

  return children;
};

export default RoleGuard;
